// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QBJAxvU72FyHZBFDALxA{height:20px;display:flex}`, "",{"version":3,"sources":["webpack://./src/entities/AICalling/ui/AICallingLabel/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,YAAA","sourcesContent":[".label {\n  height: 20px;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `QBJAxvU72FyHZBFDALxA`
};
export default ___CSS_LOADER_EXPORT___;
